import { LayoutMgrService } from './layout-mgr.service';

export const LayoutMgrInjectables: Array<any> = [
  {
    provide: LayoutMgrService,
    useClass: LayoutMgrService,
  },
];
